import {
    Box,
    Divider,
    Stack,
    Typography,
    Link,
    IconButton,
    Menu,
    Button,
  } from "@mui/material";
  import React, { useState } from "react";
  import { MdFileDownload } from "react-icons/md";
  // import CryptoJS from "crypto-js";
  import { useTheme } from "@mui/material";
  import {
    DotsThreeVertical,
    DownloadSimple,
    FileDoc,
    FilePdf,
    FilePng,
    FileText,
    FileXls,
    PlusCircle,
  } from "@phosphor-icons/react";
  import moment from "moment";
  import Lightbox from "react-image-lightbox";
  import "react-image-lightbox/style.css";
  import { useDispatch } from "react-redux";
  
  const Timeline = ({ el }) => {
    const theme = useTheme();
    // const decryptedBytes = CryptoJS.AES.decrypt(el.message, "your-secret-key");
    // const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return (
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Divider width="20%" sx={{ backgroundColor: "black", opacity: "none" }} />
        <Typography variant="caption" sx={{ color: theme.palette.text }}>
          {el.message}
        </Typography>
        <Divider width="20%" sx={{ backgroundColor: "black", opacity: "none" }} />
      </Stack>
    );
  };
  // chat component
  const TextMsg = ({ el, menu, size }) => {
    const dispatch = useDispatch();
    const handleChatbotTranscriptClick = (url) => {
      dispatch({ type: "SET_CURRENT_TAB", val: "Chatbot" });
      dispatch({
        type: "SET_CHAT_BOT_LINK",
        val: { type: "chatBot", chat_session_id: el.session_id, link: url },
      });
    };
    const addLinksToURLs = (text) => {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      const segments = text.split(urlRegex);
  
      return segments.map((segment, index) => {
        if (segment.match(urlRegex)) {
          if (text.includes("Chatbot Transcript :-")) {
            return (
              <a
                key={index}
                rel="noopener noreferrer"
                href={segment}
                onClick={(e) => {
                  e.preventDefault();
                  handleChatbotTranscriptClick(segment);
                }}
                style={{
                  color: el.fromSelf ? "#ffff" : "purple",
                  textDecoration: "underline",
                }}
              >
                {segment}
              </a>
            );
          }
          return (
            <a
              key={index}
              href={segment}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: el.fromSelf ? "#ffff" : "#000",
                textDecoration: "underline",
              }}
            >
              {segment}
            </a>
          );
        } else {
          return segment;
        }
      });
    };
  
    const processedMessage = addLinksToURLs(el.message);
    return (
      <Stack
        direction={"column"}
        justifyContent={el.fromSelf ? "end" : "start"}
        alignItems={el.fromSelf ? "flex-end" : "flex-start"}
        className="mb-3 mt-0"
      >
        <Box
          p={1}
          sx={{
            backgroundColor: el.fromSelf ? "#1473e6" : "white",
            borderRadius: el.fromSelf ? "13px 13px 0 13px" : "13px 13px 13px 0",
            width: "max-content",
            fontSize: "13px",
            height: "max-content",
            boxShadow:
              "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
          }}
          className="m-0"
        >
          <Typography
            variant="subtitle1"
            color={el.fromSelf ? "#ffff" : "#0b3363"}
            textAlign={el.fromSelf ? "end" : "start"}
            sx={{
              whiteSpace: "break-spaces",
              maxWidth: size,
              wordWrap: "break-word",
              fontSize: "13px",
              textAlign: "start",
            }}
          >
            {processedMessage}
          </Typography>
        </Box>
  
        <Stack
          justifyContent={el.fromSelf ? "end" : "start"}
          direction={"row"}
          spacing={1}
        >
          <Typography
            variant="caption"
            color={"#545455d6"}
            sx={{
              fontSize: "9px",
            }}
            className="mt-1"
          >
            {moment(el.time).format("MMM D, YYYY h:mm A")}
            <Typography
              variant="caption"
              color={"#545455d6"}
              sx={{
                fontSize: "9px",
              }}
              className="mt-1 ms-1"
            >
              {el.fromSelf ? el.senderName : el.senderName}
            </Typography>
          </Typography>
        </Stack>
      </Stack>
    );
  };
  // image uploaded chat
  const ImageMsg = ({ el, menu }) => {
    const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
    const openImagePreview = () => {
      setImagePreviewOpen(true);
    };
  
    const closeImagePreview = () => {
      setImagePreviewOpen(false);
    };
  
    const downloadImage = () => {
      const anchor = document.createElement("a");
      anchor.href = el.message;
      anchor.target = "_blank";
      anchor.click();
    };
  
    // const decryptedBytes = CryptoJS.AES.decrypt(el.message, "your-secret-key");
    // const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
  
    return (
      <Stack
        direction={"column"}
        justifyContent={el.fromSelf ? "end" : "start"}
        alignItems={el.fromSelf ? "flex-end" : "flex-start"}
        className="mb-3 mt-0"
      >
        <Box
          p={1}
          sx={{
            backgroundColor: el.fromSelf ? "#1473e6" : "white",
            borderRadius: el.fromSelf ? "13px 13px 0 13px" : "13px 13px 13px 0",
            width: "max-content",
            fontSize: "13px",
            height: "max-content",
            boxShadow:
              "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
          }}
          className="m-0"
          onClick={openImagePreview}
        >
          <Stack spacing={1}>
            <img
              src={el.message}
              alt={el.message}
              style={{
                maxHeight: "9rem",
                minWidth: "9rem",
                borderRadius: "10px",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                cursor: "pointer",
              }}
            />
          </Stack>
        </Box>
        <Stack
          justifyContent={el.fromSelf ? "end" : "start"}
          direction={"row"}
          spacing={1}
        >
          <Typography
            variant="caption"
            color={"#545455d6"}
            sx={{
              fontSize: "9px",
            }}
            className="mt-1"
          >
            {moment(el.time).format("MMM D, YYYY h:mm A")}
          </Typography>
  
          <Typography
            variant="caption"
            color={"#545455d6"}
            sx={{
              fontSize: "9px",
            }}
            className="mt-1 ms-1"
          >
            {el.fromSelf ? el.senderName : el.senderName}
          </Typography>
        </Stack>
        {imagePreviewOpen && (
          <Lightbox
            mainSrc={el.message}
            mainSrcThumbnail={el.message}
            onCloseRequest={closeImagePreview}
            toolbarButtons={[
              <Button
                variant="contained"
                sx={{ textTransform: "capitalize" }}
                size="small"
                onClick={downloadImage}
                className="me-3"
              >
                <MdFileDownload className="me-2" /> Download
              </Button>,
            ]}
          />
        )}
      </Stack>
    );
  };
  // video uploaded chat
  const VideoMsg = ({ el, menu }) => {
    const theme = useTheme();
    // const decryptedBytes = CryptoJS.AES.decrypt(el.message, "your-secret-key");
    // const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return (
      <Stack
        direction={"column"}
        justifyContent={el.fromSelf ? "end" : "start"}
        alignItems={el.fromSelf ? "flex-end" : "flex-start"}
        className="mb-3 mt-0"
      >
        <Box
          p={1}
          sx={{
            backgroundColor: el.fromSelf ? "#1473e6" : "white",
            borderRadius: el.fromSelf ? "13px 13px 0 13px" : "13px 13px 13px 0",
            width: "max-content",
            fontSize: "13px",
            height: "max-content",
            boxShadow:
              "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
          }}
          className="m-0"
        >
          <Stack>
            <video
              width="150"
              controls
              style={{
                borderRadius: "10px",
                minHeight: "8rem",
                minWidth: "12rem",
                objectFit: "cover",
                cursor: "pointer",
              }}
            >
              <source src={el.message} alt={el.message} type="video/mp4" />
            </video>
          </Stack>
        </Box>
  
        <Stack
          justifyContent={el.fromSelf ? "end" : "start"}
          direction={"row"}
          spacing={1}
        >
          <Typography
            variant="caption"
            color={"#545455d6"}
            sx={{
              fontSize: "9px",
            }}
            className="mt-1"
          >
            {moment(el.time).format("MMM D, YYYY h:mm A")}
          </Typography>
  
          <Typography
            variant="caption"
            color={"#545455d6"}
            sx={{
              fontSize: "9px",
            }}
            className="mt-1 ms-1"
          >
            {el.fromSelf ? el.senderName : el.senderName}
          </Typography>
        </Stack>
      </Stack>
    );
  };
  // files uploaded chat
  const DocMsg = ({ el, menu, type, size }) => {
    const theme = useTheme();
    // const decryptedBytes = CryptoJS.AES.decrypt(el.message, "your-secret-key");
    // const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return (
      <Stack
        direction={"column"}
        justifyContent={el.fromSelf ? "end" : "start"}
        alignItems={el.fromSelf ? "flex-end" : "flex-start"}
        className="mb-3 mt-0"
      >
        <Box
          p={0.5}
          sx={{
            backgroundColor: el.fromSelf ? "#1473e6" : "white",
            borderRadius: el.fromSelf ? "13px 13px 0 13px" : "13px 13px 13px 0",
            width: "max-content",
            fontSize: "13px",
            height: "max-content",
            boxShadow:
              "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
          }}
        >
          <Stack
            p={1}
            direction={"row"}
            spacing={1}
            alignItems={"center"}
            color={el.fromSelf ? "#ffff" : "#0b3363"}
            sx={{
              backgroundColor: "theme.palette.background.paper",
              borderRadius: 1,
            }}
          >
            {(() => {
              switch (type) {
                case "pdf":
                  return <FilePdf size={25} color="#DF5854" />;
                case "xlsx":
                  return <FileXls size={25} color="#0EB33C" />;
                case "docx":
                  return <FileDoc size={25} color="#FBC234" />;
                case "plain":
                  return <FileText size={25} color="#FBC234" />;
                default:
                  return <></>;
              }
            })()}
  
            <Typography
              variant="caption"
              sx={{
                whiteSpace: "break-spaces",
                maxWidth: size,
                wordWrap: "break-word",
                fontSize: "11px",
                cursor: "pointer",
              }}
              onClick={() => window.open(el.message, "_blank")}
            >
              {el.file_name}
            </Typography>
          </Stack>
        </Box>
  
        <Stack
          justifyContent={el.fromSelf ? "end" : "start"}
          direction={"row"}
          spacing={1}
        >
          <Typography
            variant="caption"
            color={"#545455d6"}
            sx={{
              fontSize: "9px",
            }}
            className="mt-1"
          >
            {moment(el.time).format("MMM D, YYYY h:mm A")}
          </Typography>
  
          <Typography
            variant="caption"
            color={"#545455d6"}
            sx={{
              fontSize: "9px",
            }}
            className="mt-1 ms-1"
          >
            {el.fromSelf ? el.senderName : el.senderName}
          </Typography>
        </Stack>
      </Stack>
    );
  };
  // audio uploaded chat
  const AudioMsg = ({ el, menu }) => {
    // const decryptedBytes = CryptoJS.AES.decrypt(el.message, "your-secret-key");
    // const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
    const theme = useTheme();
    return (
      <Stack
        direction={"column"}
        justifyContent={el.fromSelf ? "end" : "start"}
        alignItems={el.fromSelf ? "end" : "start"}
        className="mb-3 mt-0"
      >
        <Box
          p={0.8}
          sx={{
            backgroundColor: el.fromSelf ? "#1473e6" : "#f0f0f0",
            borderRadius: 1.5,
            width: "max-content",
            display: "flex",
            flexDirection: "column",
            gap: "2px",
          }}
        >
          <Stack direction={"row"}>
            <audio
              controls
              src={el.message}
              style={{ height: "37px", width: "15vw" }}
            ></audio>
          </Stack>
        </Box>
        <Stack
          justifyContent={el.fromSelf ? "end" : "start"}
          direction={"row"}
          spacing={1}
        >
          <Typography
            variant="caption"
            color={"#545455d6"}
            sx={{
              fontSize: "9px",
            }}
            className="mt-1"
          >
            {moment(el.time).format("MMM D, YYYY h:mm A")}
          </Typography>
  
          <Typography
            variant="caption"
            color={"#545455d6"}
            sx={{
              fontSize: "9px",
            }}
            className="mt-1 ms-1"
          >
            {el.fromSelf ? el.senderName : el.senderName}
          </Typography>
        </Stack>
      </Stack>
    );
  };
  // chat typing
  const BotChat = () => {
    return (
      <Stack className="mb-3 mt-0" direction={"row"} justifyContent={"start"}>
        <Box
          className="bot-chat-main mb-3"
          p={1.5}
          sx={{
            padding: "14px",
            backgroundColor: "white",
            borderRadius: "13px 13px 13px 0",
            boxShadow:
              "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
          }}
        >
          <Stack
            alignItems={"center"}
            justifyContent={"center"}
            spacing={0.5}
            direction={"row"}
          >
            <Box
              className="typing typing-1"
              sx={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                backgroundColor: "#000",
                marginRight: 1,
              }}
            ></Box>
            <Box
              className="typing typing-2"
              sx={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                backgroundColor: "#000",
                marginRight: 1,
              }}
            ></Box>
            <Box
              className="typing typing-3"
              sx={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                backgroundColor: "#000",
              }}
            ></Box>
          </Stack>
        </Box>
      </Stack>
    );
  };
  
  //not in use In future we will use
  // const LinkMsg = ({ el, menu }) => {
  //   const logedinAgent = JSON.parse(localStorage.getItem("tokenAgent"));
  //   const theme = useTheme();
  //   // const decryptedBytes = CryptoJS.AES.decrypt(el.message, "your-secret-key");
  //   // const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
  //   return (
  //     <Stack
  //       direction={"row"}
  //       justifyContent={el.senderName == logedinAgent.username ? "end" : "start"}
  //     >
  //       <Box
  //         p={0.8}
  //         sx={{
  //           backgroundColor:
  //             el.senderName == logedinAgent.username ? "#0B3363" : "#f0f0f0",
  //           borderRadius: 1.5,
  //           width: "max-content",
  //           display: "flex",
  //           flexDirection: "column",
  //           gap: "2px",
  //         }}
  //       >
  //         <Stack spacing={2}>
  //           <Stack
  //             p={2}
  //             spacing={2}
  //             alignItems={"center"}
  //             sx={{
  //               backgroundColor: theme.palette.background.paper,
  //               borderRadius: 1,
  //             }}
  //           >
  //             <img
  //               src={el.preview}
  //               alt={el.message}
  //               style={{ maxHeight: 150, borderRadius: "10px" }}
  //             />
  //             <Stack alignItems={"center"}>
  //               <Typography variant="subtitle2">YOYO Honey</Typography>
  //               <Typography
  //                 variant="subtitle2"
  //                 component={Link}
  //                 to="//https://www.youtube.com"
  //               >
  //                 www.youtube.com
  //               </Typography>
  //             </Stack>
  //           </Stack>
  //           <Typography
  //             variant="body2"
  //             color={el.fromSelf ? theme.palette.text : "#FFF"}
  //           >
  //             {el.message}
  //           </Typography>
  //         </Stack>
  //       </Box>
  //       {menu && <MessageOption />}
  //     </Stack>
  //   );
  // };
  const MessageOption = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    return (
      <>
        <DotsThreeVertical
          id="basic-menu"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          size={20}
          cursor={"pointer"}
        />
  
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <Stack spacing={1} px={1}>
            {/* {Message_Option.map((el) => (
              <MenuItem
                sx={{ fontSize: "13px", lineHeight: 1 }}
                onClick={() => {
                  handleClose();
                }}
              >
                {el.title}
              </MenuItem>
            ))} */}
          </Stack>
        </Menu>
      </>
    );
  };
  const LinkMsg = ({ el, menu }) => {
    const theme = useTheme();
    // const decryptedBytes = CryptoJS.AES.decrypt(el.message, "your-secret-key");
    // const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);
    return (
      <Stack
        direction={"column"}
        justifyContent={el.fromSelf ? "end" : "start"}
        alignItems={el.fromSelf ? "flex-end" : "flex-start"}
        className="mb-3 mt-0"
      >
        <Box
          p={0.8}
          sx={{
            backgroundColor: el.fromSelf ? "#0B3363" : "#f0f0f0",
            borderRadius: 1.5,
            width: "max-content",
          }}
        >
          <Stack spacing={2}>
            <Stack
              p={2}
              spacing={2}
              alignItems={"center"}
              sx={{
                backgroundColor: theme.palette.background.paper,
                borderRadius: 1,
              }}
            >
              <img
                src={el.preview}
                alt={el.message}
                style={{ maxHeight: 150, borderRadius: "10px" }}
              />
              <Stack alignItems={"center"}>
                <Typography variant="subtitle2">YOYO Honey</Typography>
                <Typography
                  variant="subtitle2"
                  component={Link}
                  to="//https://www.youtube.com"
                >
                  www.youtube.com
                </Typography>
              </Stack>
            </Stack>
            <Typography
              variant="caption"
              color={el.fromSelf ? "#ffff" : "#000"}
              sx={{ fontSize: "10px" }}
            >
              {moment(el.time).format("MMM D, YYYY h:mm A")}
            </Typography>
            <Typography
              variant="caption"
              color={el.fromSelf ? "#ffff" : "#000"}
              sx={{ fontSize: "10px" }}
              className="mt-1 ms-1"
            >
              {el.fromSelf ? el.senderName : el.senderName}
            </Typography>
          </Stack>
        </Box>
      </Stack>
    );
  };
  const ReplyMsg = ({ el, menu }) => {
    const theme = useTheme();
    return (
      <Stack direction={"row"} justifyContent={el.fromSelf ? "start" : "end"}>
        <Box
          p={0.8}
          sx={{
            backgroundColor: el.fromSelf ? "#f0f0f0" : "#0B3363",
            borderRadius: 1.5,
            width: "max-content",
            display: "flex",
            flexDirection: "column",
            gap: "2px",
          }}
        >
          <Stack spacing={2}>
            <Stack
              p={1.5}
              spacing={3}
              alignItems={"center"}
              sx={{
                backgroundColor: theme.palette.background.paper,
                borderRadius: 2,
              }}
            >
              <Typography variant="body2" color={theme.palette.text}>
                {el.message}
              </Typography>
            </Stack>
            <Typography
              variant="body2"
              color={el.fromSelf ? theme.palette.text : "#FFFF"}
            >
              {el.reply}
            </Typography>
          </Stack>
        </Box>
        {menu && <MessageOption />}
      </Stack>
    );
  };
  const AddTag = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    return (
      <>
        <PlusCircle
          id="basic-menu"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          size={16}
          cursor={"pointer"}
        />
  
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <Stack spacing={1} px={1}></Stack>
        </Menu>
      </>
    );
  };
  
  export {
    Timeline,
    TextMsg,
    ImageMsg,
    DocMsg,
    LinkMsg,
    ReplyMsg,
    BotChat,
    AudioMsg,
    VideoMsg,
  };
  